import { axiosCall } from "./axiosCall";

export function validateField(fieldName, value, validations = [], errors) {
  if (typeof errors[fieldName] === "undefined") {
    errors[fieldName] = [];
  }
  if (typeof validations === "undefined" || !validations) {
    validations = [];
  }
  for (var i = 0; i < validations.length; i++) {
    switch (validations[i]) {
      case "required":
        if (!value) {
          errors[fieldName].push("required");
        }
        break;
      case "requiredArr":
        if (!value) {
          errors[fieldName].push("requiredArr");
        }
        if (Array.isArray(value) && value.length === 0) {
          errors[fieldName].push("requiredArr");
        }
        break;
      case "float":
        if (isNaN(parseFloat(value))) {
          errors[fieldName].push("float");
        }
        break;
      case "email":
        if (!validateEmail(value)) {
          errors[fieldName].push("email");
        }
        break;
    }
  }
  return errors;
}
export async function validateFieldAsync(
  fieldName,
  value,
  validations = [],
  errors
) {
  if (typeof errors[fieldName] === "undefined") {
    errors[fieldName] = [];
  }
  if (typeof validations === "undefined" || !validations) {
    validations = [];
  }
  for (let i = 0; i < validations.length; i++) {
    if (validations[i].includes("not_duplicated") && value) {
      const splitValidations = validations[i].split("|");
      const endpoint = splitValidations[1];
      const field = splitValidations[2];
      const where = { where: {} };
      where["where"][field] = (value || '').toLowerCase();
      await axiosCall({
        url: `${endpoint}?filter=` + JSON.stringify(where),
        method: "get",
      }).then((response) => {
        if (response && response.data && response.data.length) {
          errors[fieldName].push("duplicated");
        }
      });
    }
  }
  return errors;
}

export function calculateStrata(N, z = 1.96, o = 0.5, e = 0.05) {
  const numerator = z * z * o * o * N;
  const denominator = e * e * (N - 1) + z * z * o * o;
  return Math.ceil(numerator / denominator);
}

export function calculateStratified(N) {
  const numerator = N * 5;
  const denominator = 9;
  return Math.ceil(numerator / denominator);
}

function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function FormField(
  name,
  value,
  type,
  selectTableName = null,
  selectId = null,
  selectName = null,
  selectOptions = [],
  validations = [],
  selectOptionsName = null,
  fieldCategory = null,
  fieldRules = [],
  isSecret = false
) {
  this.name = name;
  this.value = value;
  this.type = type;
  this.valueConfirmation = null;
  this.selectTablename = selectTableName;
  this.selectId = selectId;
  this.selectName = selectName;
  this.selectOptions = selectOptions;
  this.validations = validations;
  this.selectOptionsName = selectOptionsName;
  this.fieldCategory = fieldCategory;
  this.fieldRules = fieldRules;
  this.isSecret = isSecret
}

export function CreateManyToMany(
  tableName,
  id,
  name,
  breakingTableName,
  localField,
  foreignField,
  nameField = "name",
  splitCharacter = null,
  fieldsToDisplay = null
) {
  this.tableName = tableName;
  this.id = id;
  this.name = name;
  this.breakingTableName = breakingTableName;
  this.localField = localField;
  this.foreignField = foreignField;
  this.nameField = nameField;
  this.splitCharacter = splitCharacter;
  this.fieldsToDisplay = fieldsToDisplay || [{field:name}];
}

export const FieldType = {
  INPUT: "input",
  SELECT: "select",
  CHECKBOX: "checkbox",
  SELECT_LIST: "select_list",
  DATE_PICKER: "date_picker",
  BOOLEAN: "boolean",
};

export const Action = {
  NEW: "post",
  UPDATE: "put",
};
